<span class="filter-icon">
    <button icon="{{fromProductVisibilityModule ? 'pi pi-plus' : 'pi pi-filter'}}" pButton pRipple type="button" class="p-button-text"
        [ngClass]="{'p-button-secondary': secondaryClass}"
        (click)="filterOptions.toggle($event);resetToAppliedFilters()" pTooltip="{{fromProductVisibilityModule ? 'Rules' : 'Filters'}}"
        tooltipPosition="top"></button>
    <span *ngIf="appliedSlectedColumns?.length > 0 && empltyFields.length == 0" class="filter-badge"></span>
</span>

<p-overlayPanel #filterOptions [showCloseIcon]="true" [style]="{width: '650px'}">
    <ng-template pTemplate>
        <h5>{{fromProductVisibilityModule ? 'Rules' : 'Filters'}}</h5>
        <div class="p-grid">
            <div class="p-col-2">&nbsp;</div>
            <div class="p-col-3">{{fromProductVisibilityModule ? 'Rules' : 'Filters'}}</div>
            <div class="p-col-3">Operator</div>
            <div class="p-col-3">Value</div>
        </div>
        <div class="p-grid" *ngFor="let filterItem of filters;let index = index;">
            <div class="p-col-2">
                <div class="p-mt-2" *ngIf="index == 0">Where</div>
                <p-dropdown *ngIf="index !== 0" [options]="choices" [(ngModel)]="filterItem.choice" optionLabel="name"
                    (onChange)="changeCondition($event,index,filterItem)" [disabled]="index != 1"></p-dropdown>
            </div>
            <div class="p-col-3 filterItemWidth">
                <p-dropdown [options]="filterItem?.fields" [(ngModel)]="filterItem.selectedField"
                    placeholder="Select Field" optionLabel="name" [filter]="true" [resetFilterOnHide]="true"
                    (onChange)="changeFilter($event,filterItem)"></p-dropdown>
                <div style="color:red;font-size: 12px;" *ngIf="filterItem?.isRequired?.isFieldRequired">
                    <span>Field is required</span>
                </div>
                <div style="color:red;font-size: 12px;" *ngIf="filterItem?.isRequired?.isCountryRequired">
                    <span>Country is required</span>
                </div>
                <div style="color:red;font-size: 12px;" *ngIf="filterItem?.isRequired?.isStateRequired">
                    <span>State is required</span>
                </div>
            </div>
            <div class="p-col-3 filterItemWidth">
                <p-dropdown [options]="filterItem.operators" [(ngModel)]="filterItem.selectedOperator"
                    (onChange)="onSelectedOperator($event,filterItem)" placeholder="Select Operator"></p-dropdown>
                <div style="color:red;font-size: 12px;" *ngIf="filterItem?.isRequired?.isOperatorRequired">
                    <span>Operator is required</span>
                </div>
            </div>
            <div class="p-col-3 filterItemWidth">

                @if(autocompleteFields.includes(filterItem.columnName) && !(filterItem.hasValue || filterItem.noValue)){

                    <p-autoComplete #parent [suggestions]="filterItem.valueList"
                        [(ngModel)]="filterItem.selectedValue" name="parent" placeholder="Search..."
                        field="name" [completeOnFocus]="true"
                        (completeMethod)="searchAutocompleteItems($event, filterItem)" id="parent" appendTo="body"
                        dataKey="id" inputId="parent" name="selectedParentAccount"
                        [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="onValueChange($event,filterItem)">
                        <ng-template let-obj pTemplate="item">
                            {{obj.name | shorten:60}}
                        </ng-template>
                    </p-autoComplete>
                    
                    <div>
                        <p-autoComplete 
                            *ngIf="autoCompleteFieldsForBetweenNotBetween.includes(filterItem.columnName) && (filterItem.selectedOperator == 'Between' || filterItem.selectedOperator == 'NotBetween')"
                            #autocompletechild [suggestions]="filterItem.valueList"
                            [(ngModel)]="filterItem.selectedValue2" name="autocompletechild" placeholder="Search..."
                            field="name" [completeOnFocus]="true"
                            (completeMethod)="searchAutocompleteItems($event, filterItem)" id="autocompletechild" appendTo="body"
                            dataKey="id" inputId="autocompletechild" name="selectedParentAccount"
                            [ngModelOptions]="{standalone: true}"
                            (ngModelChange)="onValueChange($event,filterItem)">
                            <ng-template let-obj pTemplate="item">
                                {{obj.name | shorten:60}}
                            </ng-template>
                        </p-autoComplete>
                    </div>
                    <div style="color:red;font-size: 12px;" *ngIf="filterItem?.isRequired?.isValueRequired">
                        <span>Value is required</span>
                    </div>

                }@else{

                    <!-- String -->
                    <ng-container *ngIf="filterItem.fieldDataType == 'String'">
                        <ng-container>
                            <!-- Input -->
                            <ng-container *ngIf="['InputBox','Email','Phone','URL','RichText','Barcode','IPAddress','EncryptedText','Multi-Line','AutoNumber'].includes(filterItem.formControlType) && !(filterItem.hasValue || filterItem.noValue)">
                                <span class="p-input-icon-right">
                                    <!-- <i class="pi pi-times cursor-pointer" (click)="filterItem.selectedValue = ''"></i> -->
                                    <input pInputText type="text" #inputS [(ngModel)]="filterItem.selectedValue"
                                        placeholder="Enter Value" class="p-column-filter w-100"
                                        (ngModelChange)="onValueChange($event,filterItem)">
                                </span>
                                <div style="color:red;font-size: 12px;" *ngIf="filterItem?.isRequired?.isValueRequired">
                                    <span>Value is required</span>
                                </div>
                            </ng-container>
                            <ng-container
                                *ngIf="filterItem.formControlType == 'DropDownList' && !(filterItem.hasValue || filterItem.noValue)">
                                <p-autoComplete #parent [suggestions]="filterItem.valueList"
                                    [(ngModel)]="filterItem.selectedValue" name="parent" placeholder="Search..."
                                    field="name" [completeOnFocus]="true"
                                    (completeMethod)="searchParentAccounts($event, filterItem)" id="parent" appendTo="body"
                                    dataKey="id" inputId="parent" name="selectedParentAccount"
                                    [ngModelOptions]="{standalone: true}"
                                    (ngModelChange)="onValueChange($event,filterItem)">
                                </p-autoComplete>
                                <div style="color:red;font-size: 12px;" *ngIf="filterItem?.isRequired?.isValueRequired">
                                    <span>Value is required</span>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="filterItem.hasValue || filterItem.noValue">
                                <span class="p-input-icon-right">
                                    <!-- <i class="pi pi-times cursor-pointer" (click)="filterItem.selectedValue = ''"></i> -->
                                    <input pInputText type="text" #inputS [(ngModel)]="filterItem.selectedValue"
                                        class="p-column-filter w-100" [disabled]="filterItem.hasValue || filterItem.noValue"
                                        (ngModelChange)="onValueChange($event,filterItem)">
                                </span>
                                <div style="color:red;font-size: 12px;" *ngIf="filterItem?.isRequired?.isValueRequired">
                                    <span>Value is required</span>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="filterItem.formControlType == 'DatePicker'">
                                <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true"
                                    placeholder="mm/dd/yyyy" dateFormat="mm/dd/yy" yearRange="1900:2100"
                                    [ngModelOptions]="{standalone: true}" [(ngModel)]="filterItem.selectedValue"
                                    (ngModelChange)="onValueChange($event,filterItem)">
                                </p-calendar>
                                <div style="color:red;font-size: 12px;" *ngIf="filterItem?.isRequired?.isValueRequired">
                                    <span>Value is required</span>
                                </div>
                            </ng-container>
                        </ng-container>
                    </ng-container>

                    <!-- Boolean -->
                    <ng-container *ngIf="filterItem.fieldDataType == 'Boolean'">
                        <ng-container
                            *ngIf="(filterItem?.formControlType == 'DropDownList' || filterItem?.formControlType == 'ToggleButton') && filterItem.isCustom &&  !(filterItem.hasValue || filterItem.noValue)">
                            <p-dropdown [options]="filterItem.valueList"
                                [(ngModel)]="filterItem.selectedValue" placeholder="Select Item"
                                (ngModelChange)="onValueChange($event,filterItem)">
                            </p-dropdown>
                            <div style="color:red;font-size: 12px;" *ngIf="filterItem?.isRequired?.isValueRequired">
                                <span>Value is required</span>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="filterItem.hasValue || filterItem.noValue">
                            <span class="p-input-icon-right">
                                <!-- <i class="pi pi-times cursor-pointer" (click)="filterItem.selectedValue = ''"></i> -->
                                <input pInputText type="text" #inputS [(ngModel)]="filterItem.selectedValue"
                                    class="p-column-filter w-100" [disabled]="filterItem.hasValue || filterItem.noValue"
                                    (ngModelChange)="onValueChange($event,filterItem)">
                            </span>
                            <div style="color:red;font-size: 12px;" *ngIf="filterItem?.isRequired?.isValueRequired">
                                <span>Value is required</span>
                            </div>
                        </ng-container>
                    </ng-container>

                    <!-- Decimal And Number -->
                    <ng-container *ngIf="['Decimal','Number','Currency','Percentage'].includes(filterItem.fieldDataType)">
                        <ng-container *ngIf="!(filterItem.hasValue || filterItem.noValue)">
                            <span class="p-input-icon-right">
                                <!-- <i class="pi pi-times cursor-pointer" (click)="filterItem.selectedValue = ''"></i> -->
                                <input pInputText type="number" #inputS [(ngModel)]="filterItem.selectedValue"
                                    class="p-column-filter w-100" [disabled]="filterItem.hasValue || filterItem.noValue"
                                    (ngModelChange)="onValueChange($event,filterItem)">
                                <div>
                                    <input
                                        *ngIf="filterItem.selectedOperator == 'Between' || filterItem.selectedOperator == 'NotBetween'"
                                        pInputText type="number" #inputS
                                        [(ngModel)]="filterItem.decimalBetweenNotBetweenValue" class="p-column-filter w-100"
                                        [disabled]="filterItem.hasValue || filterItem.noValue"
                                        (ngModelChange)="onValueChange($event,filterItem)">
                                </div>
                            </span>
                            <div style="color:red;font-size: 12px;" *ngIf="filterItem?.isRequired?.isValueRequired">
                                <span>Value is required</span>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="filterItem.hasValue || filterItem.noValue">
                            <span class="p-input-icon-right">
                                <!-- <i class="pi pi-times cursor-pointer" (click)="filterItem.selectedValue = ''"></i> -->
                                <input pInputText type="text" #inputS [(ngModel)]="filterItem.selectedValue"
                                    class="p-column-filter w-100" [disabled]="filterItem.hasValue || filterItem.noValue"
                                    (ngModelChange)="onValueChange($event,filterItem)">
                            </span>
                            <div style="color:red;font-size: 12px;" *ngIf="filterItem?.isRequired?.isValueRequired">
                                <span>Value is required</span>
                            </div>
                        </ng-container>
                    </ng-container>

                    <!-- Enum -->
                    <ng-container *ngIf="filterItem.fieldDataType == 'Enum'">
                        <!-- ----- has value ------>
                        <ng-container *ngIf="filterItem.hasValue || filterItem.noValue">
                            <span class="p-input-icon-right">
                                <input pInputText type="text" #inputS [(ngModel)]="filterItem.selectedValue"
                                    placeholder="Enter" class="p-column-filter w-100"
                                    [disabled]="filterItem.hasValue || filterItem.noValue"
                                    (ngModelChange)="onValueChange($event,filterItem)">
                            </span>
                            <div style="color:red;font-size: 12px;" *ngIf="filterItem?.isRequired?.isValueRequired">
                                <span>Value is required</span>
                            </div>
                        </ng-container>

                        <!-- DropDownList -->

                        <ng-container *ngIf="singleSelectFields.includes(filterItem.columnName) && filterItem?.formControlType == 'DropDownList' && !(filterItem.hasValue || filterItem.noValue)">
                            <p-dropdown [options]="filterItem.valueList" optionLabel="name"
                                [(ngModel)]="filterItem.selectedValue" [filter]="true" [resetFilterOnHide]="true"
                                placeholder="Select Item" (ngModelChange)="onValueChange($event,filterItem)">
                            </p-dropdown>
                            <div style="color:red;font-size: 12px;" *ngIf="filterItem?.isRequired?.isValueRequired">
                                <span>Value is required</span>
                            </div>
                        </ng-container>

                        <!-- MultiSelect -->

                        <ng-container
                            *ngIf="!singleSelectFields.includes(filterItem.columnName) && (filterItem?.formControlType == 'DropDownList' || filterItem?.formControlType == 'MultipleDropDownList') && !filterItem.isCustom && !(filterItem.hasValue || filterItem.noValue)">
                            <!-- this works -->
                            <p-multiSelect class="p-column-filter w-100" appendTo="body" [options]="filterItem.valueList"
                                [(ngModel)]="filterItem.selectedValue" optionLabel="name" placeholder="Select Items"
                                (ngModelChange)="onValueChange($event,filterItem)">
                                <ng-container *ngIf="filterItem.columnName!='WarehouseName'">
                                    <ng-template let-obj pTemplate="selectedItem">
                                        <span pTooltip="{{obj.name}}" tooltipPosition="top">
                                            {{ (obj.name.length>40)? (obj.name | slice:0:40)+'..':(obj.name) }}
                                        </span>
                                    </ng-template>
                                </ng-container>
                                <ng-container *ngIf="filterItem.columnName=='WarehouseName'">
                                    <ng-template let-obj pTemplate="selectedItem">
                                        <span pTooltip="{{obj.name}}" tooltipPosition="top">
                                            {{ (obj.customName) }}
                                        </span>
                                    </ng-template>
                                </ng-container>
                            </p-multiSelect>
                            <div style="color:red;font-size: 12px;" *ngIf="filterItem?.isRequired?.isValueRequired">
                                <span>Value is required</span>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="(filterItem?.formControlType == 'DropDownList' || filterItem?.formControlType == 'MultipleDropDownList' || filterItem?.formControlType == 'CheckBox' || filterItem?.formControlType == 'RadioButton') && filterItem.isCustom && !(filterItem.hasValue || filterItem.noValue)&& !isWorkspaceModule">
                            <p-multiSelect class="p-column-filter w-100" appendTo="body" [options]="filterItem.valueList"
                                [(ngModel)]="filterItem.selectedValue" placeholder="Select Items"
                                (ngModelChange)="onValueChange($event,filterItem)">
                            </p-multiSelect>
                            <div style="color:red;font-size: 12px;" *ngIf="filterItem?.isRequired?.isValueRequired">
                                <span>Value is required</span>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="(filterItem?.formControlType == 'UserLookup') && filterItem.isCustom && !(filterItem.hasValue || filterItem.noValue)">
                            <p-multiSelect class="p-column-filter w-100" appendTo="body" optionLabel="name" [options]="filterItem.valueList"
                                [(ngModel)]="filterItem.selectedValue" placeholder="Select Items"
                                (ngModelChange)="onValueChange($event,filterItem)">
                            </p-multiSelect>
                            <div style="color:red;font-size: 12px;" *ngIf="filterItem?.isRequired?.isValueRequired">
                                <span>Value is required</span>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="(filterItem?.formControlType == 'DropDownList' || filterItem?.formControlType == 'MultipleDropDownList' || filterItem?.formControlType == 'CheckBox' || filterItem?.formControlType == 'RadioButton') && filterItem.isCustom && !(filterItem.hasValue || filterItem.noValue)&& isWorkspaceModule">                           
                            <p-multiSelect [options]="filterItem.valueList" [(ngModel)]="filterItem.selectedValue" placeholder="Search..."
                                (onFocus)="searchAutocompleteItems($event, filterItem)" appendTo="body"
                                (onFilter)="searchAutocompleteItems($event, filterItem)" optionLabel="value" optionValue="value" [ngModelOptions]="{standalone: true}"
                                [multiple]="true" [filter]="true">
                                <ng-template let-obj pTemplate="item">
                                    {{ obj.value | shorten:60 }}
                                </ng-template>
                            </p-multiSelect>
                        </ng-container>
                            
                        <!-- DropdownList -->
                        <ng-container
                            *ngIf="(filterItem?.formControlType == 'Rating') && !(filterItem.hasValue || filterItem.noValue)">
                            <span class="p-input-icon-right">
                                <input pInputText type="number" #inputS [(ngModel)]="filterItem.selectedValue"
                                    class="p-column-filter w-100" [disabled]="filterItem.hasValue || filterItem.noValue"
                                    (ngModelChange)="onValueChange($event,filterItem)">
                                <div>
                                    <input
                                        *ngIf="filterItem.selectedOperator == 'Between' || filterItem.selectedOperator == 'NotBetween'"
                                        pInputText type="number" #inputS
                                        [(ngModel)]="filterItem.decimalBetweenNotBetweenValue" class="p-column-filter w-100"
                                        [disabled]="filterItem.hasValue || filterItem.noValue"
                                        (ngModelChange)="onValueChange($event,filterItem)">
                                </div>
                            </span>
                            <div style="color:red;font-size: 12px;" *ngIf="filterItem?.isRequired?.isValueRequired">
                                <span>Value is required</span>
                            </div>
                        </ng-container>

                        <!-- TreeSelect -->
                        <ng-container *ngIf="filterItem.formControlType == 'TreeSelect' && !(filterItem.hasValue || filterItem.noValue)">
                            <p-treeSelect  [(ngModel)]="filterItem.selectedValue" [options]="filterItem.treeSelectData" 
                            appendTo="body" placeholder="Select Item" [filter]="true" [metaKeySelection]="false" 
                            selectionMode="multiple" display="comma" class="custom-treeselect">
                            </p-treeSelect>
                        </ng-container>
                    </ng-container>

                    <!-- DateTime -->
                    <ng-container *ngIf="filterItem.fieldDataType == 'DateTime'">

                        <ng-container *ngIf="!(filterItem.hasValue || filterItem.noValue)">
                            <p-dropdown *ngIf="['On','NotOn'].includes(filterItem.selectedOperator)"
                                [options]="dataIsOperatorList" [(ngModel)]="filterItem.selectedValue" [filter]="true"
                                [resetFilterOnHide]="true" placeholder="Select Item"
                                (ngModelChange)="onValueChange($event,filterItem)">
                            </p-dropdown>
                            <p-calendar *ngIf="!['Between','On','NotOn'].includes(filterItem.selectedOperator)"
                                appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="mm/dd/yyyy"
                                dateFormat="mm/dd/yy" yearRange="1900:2100" [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="filterItem.selectedValue" (ngModelChange)="onValueChange($event,filterItem)">
                            </p-calendar>
                            <p-calendar *ngIf="filterItem.selectedOperator == 'Between'" appendTo="body"
                                selectionMode="range" [monthNavigator]="true" [yearNavigator]="true"
                                placeholder="mm/dd/yyyy to mm/dd/yyyy" dateFormat="mm/dd/yy" yearRange="1900:2100"
                                [ngModelOptions]="{standalone: true}" [(ngModel)]="filterItem.selectedValue"
                                (ngModelChange)="onValueChange($event,filterItem)">
                            </p-calendar>
                            <div style="color:red;font-size: 12px;" *ngIf="filterItem?.isRequired?.isValueRequired">
                                <span>Value is required</span>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="filterItem.hasValue || filterItem.noValue">
                            <span class="p-input-icon-right">
                                <input pInputText type="text" #inputS [(ngModel)]="filterItem.selectedValue"
                                    class="p-column-filter w-100" [disabled]="filterItem.hasValue || filterItem.noValue"
                                    (ngModelChange)="onValueChange($event,filterItem)">
                            </span>
                            <div style="color:red;font-size: 12px;" *ngIf="filterItem?.isRequired?.isValueRequired">
                                <span>Value is required</span>
                            </div>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="filterItem.fieldDataType == 'Time'">
                        <ng-container *ngIf="!(filterItem.hasValue || filterItem.noValue)">
                            <ng-container *ngIf="!['Between'].includes(filterItem.selectedOperator)">
                                <input pInputText type="time" #inputS [(ngModel)]="filterItem.selectedValue"
                                class="p-column-filter w-100" [disabled]="filterItem.hasValue || filterItem.noValue"
                                (ngModelChange)="onValueChange($event,filterItem)">
                            </ng-container>
                            <ng-container *ngIf="['Between'].includes(filterItem.selectedOperator)">
                                <div>
                                    <input pInputText type="time" #inputS [(ngModel)]="filterItem.selectedValue"
                                        class="p-column-filter w-100" [disabled]="filterItem.hasValue || filterItem.noValue"
                                        (ngModelChange)="onValueChange($event,filterItem)">
                                    <input pInputText type="time" #inputS2 [(ngModel)]="filterItem.selectedValue2"
                                        class="p-column-filter w-100 p-mt-1" [disabled]="filterItem.hasValue || filterItem.noValue"
                                        (ngModelChange)="onValueChange($event,filterItem)">
                                </div>
                            </ng-container>
                            <div style="color:red;font-size: 12px;" *ngIf="filterItem?.isRequired?.isValueRequired">
                                <span>Value is required</span>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="filterItem.hasValue || filterItem.noValue">
                            <span class="p-input-icon-right">
                                <input pInputText type="text" #inputS [(ngModel)]="filterItem.selectedValue"
                                    class="p-column-filter w-100" [disabled]="filterItem.hasValue || filterItem.noValue"
                                    (ngModelChange)="onValueChange($event,filterItem)">
                            </span>
                            <div style="color:red;font-size: 12px;" *ngIf="filterItem?.isRequired?.isValueRequired">
                                <span>Value is required</span>
                            </div>
                        </ng-container>
                    </ng-container>

                } <!-- End Else Part -->
            </div>
            <div class="p-col-1">
                <span *ngIf="index !== 0" class="btnBars p-mt-1" (click)="removeFilter(index)">
                    <i class="pi pi-trash"></i>
                </span>
            </div>
        </div>
        <div class="p-d-flex p-jc-between">
            <p-button icon="pi pi-plus" label="{{fromProductVisibilityModule ? 'Add Rule' : 'Add Filter'}}" (click)="addFilter()"></p-button>
            <div class="p-mr-3">
                <button pButton pRipple type="button" label="Reset" class="p-button-secondary p-mr-2"
                    (click)="resetFilter();filterOptions.hide();"></button>
                <button pButton pRipple type="button" label="Apply" (click)="applyFilters()"></button>
            </div>
        </div>
    </ng-template>
</p-overlayPanel>
